import React from 'react'
import { cn } from '@/lib/utils'

interface Props {
  label: string
  htmlFor?: string
  hint?: string
  error?: string
  className?: string
  children: React.ReactNode
}

/** Label, control, then the error (red) or the hint (gray): the field layout of the resource forms. */
export const FormField = ({ label, htmlFor, hint, error, className, children }: Props) => (
  <div className={cn('space-y-1.5', className)}>
    <label htmlFor={htmlFor} className="text-sm font-medium text-gray-700">{label}</label>
    {children}
    {error ? <p role="alert" className="text-xs text-red-600">{error}</p> : hint ? <p className="text-xs text-gray-500">{hint}</p> : null}
  </div>
)
